module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "add-user-search-modal",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("ADD NEW " + _vm._s(_vm.participantSingularName.toUpperCase()) + " SEARCH")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-body"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input has-warning"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-control input-icon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Type to search...",
      "value": ""
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn btn-right"
  }, [_c('button', {
    ref: "searchBtn",
    staticClass: "btn green mt-ladda-btn ladda-button search-btn-submit",
    attrs: {
      "type": "submit",
      "data-style": "expand-left"
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Search")])])])])])]), _vm._v(" "), (_vm.haveResults) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "pagination-options": {
        enabled: true,
        perPageDropdown: [10, 20, 50, 100, 200, 500],
        dropdownAllowAll: true,
        perPage: this.serverParams.perPage
      },
      "mode": "remote",
      "totalRows": _vm.totalRecords
    },
    on: {
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'participant_name') ? _c('span', [(props.row.organization.map(function (item) { return item.id; }).includes(_vm.user.organizations[0].id)) ? _c('router-link', {
          attrs: {
            "to": {
              name: 'Dashboard Participant',
              params: {
                id: props.row.id
              }
            },
            "tag": "a",
            "data-dismiss": "modal",
            "aria-hidden": "true"
          }
        }, [_vm._v(_vm._s(props.row.participant_name) + "\n                    ")]) : _c('span', [_vm._v(_vm._s(props.row.participant_name))])], 1) : (props.column.field == 'date_completed.date') ? _c('span', [_vm._v(_vm._s(_vm._f("formatDateModalNoTimeZone")(props.row.date_completed && props.row.date_completed.hasOwnProperty('date') ? props.row.date_completed.date : '')))]) : (props.column.field == 'date_of_birth.date') ? _c('span', [_vm._v(_vm._s(_vm._f("formatDateModalNoTimeZone")(props.row.date_of_birth && props.row.date_of_birth.hasOwnProperty('date') ? props.row.date_of_birth.date : '')))]) : (props.column.field == 'action') ? _c('span', [(!props.row.organization.map(function (item) { return item.id; }).includes(_vm.user.organizations[0].id)) ? _c('button', {
          staticClass: "btn btn-sm green",
          on: {
            "click": function($event) {
              return _vm.addParticipantFromAnotherOrganization(props.row.id)
            }
          }
        }, [_vm._v("Add")]) : _vm._e()]) : (props.column.field == 'organization') ? _c('span', [_vm._v("\n                  " + _vm._s(props.row.organization.map(function (item) { return item.name; }).join(',')) + "\n                ")]) : _c('span', [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]
      }
    }], null, false, 619601875)
  }) : _vm._e(), _vm._v(" "), (_vm.notFound) ? _c('div', {
    staticClass: "not-found-results"
  }, [_c('h4', [_vm._v("Sorry, no search results were found.")]), _vm._v(" "), _c('h5', [_vm._v("Search Suggestions:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Check your spelling")]), _vm._v(" "), _c('li', [_vm._v("Search by " + _vm._s(_vm.participantSingularName) + " Name, System ID or Organization ID")])])]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.user.access > 2) ? _c('router-link', {
    attrs: {
      "to": "/admin/participant"
    }
  }, [_c('button', {
    staticClass: "btn green",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Add New " + _vm._s(_vm.participantSingularName))])]) : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a4ba443","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/AddUserSearchModal.vue
// module id = 1633
// module chunks = 1